import { render, staticRenderFns } from "./ReservierungRow.vue?vue&type=template&id=bbf26134"
import script from "./ReservierungRow.vue?vue&type=script&lang=ts"
export * from "./ReservierungRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports